"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USE_STRIPE_PURSHACE = exports.USE_SECONDARY_COLOR = exports.USE_CREDIT_CARDS = exports.STATIC_PATH = exports.SHOW_USER_CONDITIONS = exports.REGISTER_FORM_URL = exports.REDIRECT_AFTER_REGISTER_URL = exports.REDIRECT_AFTER_LOGIN_URL = exports.NAVBAR_LOGO_PATH = exports.NAME_ORDER_IN_CHAT = exports.LOGO_PATH = exports.LOGO_LINK_URL = exports.LOGO_LINK = exports.IS_VALIDATE_BY_EMAIL = exports.INLINE_STORE_IN_REGISTER = exports.INLINE_ROLE_IN_REGISTER = exports.INLINE_PRODUCT_IN_REGISTER = exports.INLINE_ADDRESS_OF_STORE_IN_REGISTER = exports.DISPLAY_SAFARI_LOREM = exports.DEFAULT_PHONE_COUNTRY = exports.DEFAULT_LOCALE = exports.CUSTOM_REGISTER = exports.BASE_URL = exports.BASE_APP_URL = exports.BASE_API_URL = void 0;
var _Utils = require("react-platform-components/dist/Utils");
var BASE_API_URL = (0, _Utils.getBackendConfig)("REACT_BASE_API_URL", process.env.REACT_APP_BASE_API_URL);
exports.BASE_API_URL = BASE_API_URL;
var BASE_URL = (0, _Utils.getBackendConfig)("REACT_BASE_URL", process.env.REACT_APP_BASE_URL);
exports.BASE_URL = BASE_URL;
var STATIC_PATH = process.env.PUBLIC_URL || "";
exports.STATIC_PATH = STATIC_PATH;
var BASE_APP_URL = process.env.REACT_APP_BASE_APP_URL;
exports.BASE_APP_URL = BASE_APP_URL;
var REDIRECT_AFTER_LOGIN_URL = process.env.REACT_APP_REDIRECT_AFTER_LOGIN_URL || "/dashboard";
exports.REDIRECT_AFTER_LOGIN_URL = REDIRECT_AFTER_LOGIN_URL;
var REDIRECT_AFTER_REGISTER_URL = process.env.REACT_APP_REDIRECT_AFTER_REGISTER_URL || "/login";
exports.REDIRECT_AFTER_REGISTER_URL = REDIRECT_AFTER_REGISTER_URL;
var LOGO_PATH = process.env.REACT_APP_LOGO_PATH ? "".concat(STATIC_PATH, "/assets/images/").concat(process.env.REACT_APP_LOGO_PATH) : undefined;
// we use NAVBAR_LOGO_PATH to define the path of logo of register and login pages
// example REACT_APP_NAVBAR_LOGO_PATH = 'logos/logo.png'
exports.LOGO_PATH = LOGO_PATH;
var NAVBAR_LOGO_PATH = process.env.REACT_APP_NAVBAR_LOGO_PATH ? "".concat(STATIC_PATH, "/assets/images/").concat(process.env.REACT_APP_NAVBAR_LOGO_PATH) : undefined;
exports.NAVBAR_LOGO_PATH = NAVBAR_LOGO_PATH;
var INLINE_STORE_IN_REGISTER = process.env.REACT_APP_INLINE_STORE_IN_REGISTER || false;
exports.INLINE_STORE_IN_REGISTER = INLINE_STORE_IN_REGISTER;
var CUSTOM_REGISTER = process.env.REACT_APP_CUSTOM_REGISTER || false;
exports.CUSTOM_REGISTER = CUSTOM_REGISTER;
var INLINE_ROLE_IN_REGISTER = process.env.REACT_APP_INLINE_ROLE_IN_REGISTER || false;
exports.INLINE_ROLE_IN_REGISTER = INLINE_ROLE_IN_REGISTER;
var INLINE_PRODUCT_IN_REGISTER = process.env.REACT_APP_INLINE_PRODUCT_IN_REGISTER || false;
exports.INLINE_PRODUCT_IN_REGISTER = INLINE_PRODUCT_IN_REGISTER;
var INLINE_ADDRESS_OF_STORE_IN_REGISTER = process.env.REACT_APP_INLINE_ADDRESS_OF_STORE_IN_REGISTER || false;
exports.INLINE_ADDRESS_OF_STORE_IN_REGISTER = INLINE_ADDRESS_OF_STORE_IN_REGISTER;
var USE_CREDIT_CARDS = process.env.REACT_APP_USE_CREDIT_CARDS || false;
exports.USE_CREDIT_CARDS = USE_CREDIT_CARDS;
var SHOW_USER_CONDITIONS = process.env.REACT_APP_SHOW_USER_CONDITIONS === "false" ? false : true;
exports.SHOW_USER_CONDITIONS = SHOW_USER_CONDITIONS;
var USE_STRIPE_PURSHACE = process.env.REACT_APP_USE_STRIPE_PURSHACE === "true" ? true : false;
exports.USE_STRIPE_PURSHACE = USE_STRIPE_PURSHACE;
var LOGO_LINK = process.env.REACT_APP_LOGO_LINK || false;
exports.LOGO_LINK = LOGO_LINK;
var LOGO_LINK_URL = process.env.REACT_APP_LOGO_LINK_URL || false;
exports.LOGO_LINK_URL = LOGO_LINK_URL;
var DEFAULT_LOCALE = process.env.REACT_APP_DEFAULT_LOCALE || "fr";
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
var DISPLAY_SAFARI_LOREM = process.env.REACT_APP_DISPLAY_SAFARI_LOREM || false;
exports.DISPLAY_SAFARI_LOREM = DISPLAY_SAFARI_LOREM;
var REGISTER_FORM_URL = process.env.REACT_APP_REGISTER_FORM_URL || "/register";
exports.REGISTER_FORM_URL = REGISTER_FORM_URL;
var NAME_ORDER_IN_CHAT = process.env.REACT_APP_NAME_ORDER_IN_CHAT || "";
exports.NAME_ORDER_IN_CHAT = NAME_ORDER_IN_CHAT;
var IS_VALIDATE_BY_EMAIL = process.env.REACT_APP_IS_VALIDATE_BY_EMAIL === "false" ? false : true;
exports.IS_VALIDATE_BY_EMAIL = IS_VALIDATE_BY_EMAIL;
var USE_SECONDARY_COLOR = process.env.REACT_APP_USE_SECONDARY_COLOR;
exports.USE_SECONDARY_COLOR = USE_SECONDARY_COLOR;
var DEFAULT_PHONE_COUNTRY = process.env.REACT_APP_DEFAULT_PHONE_COUNTRY || "fr";
exports.DEFAULT_PHONE_COUNTRY = DEFAULT_PHONE_COUNTRY;